const map = {
	"./en/labels.json5": [
		57775,
		[
			775
		]
	],
	"./en/messages.json5": [
		73070,
		[
			70
		]
	],
	"./en/states.json5": [
		4656,
		[
			656
		]
	],
	"./it/labels.json5": [
		32497,
		[
			497
		]
	],
	"./it/messages.json5": [
		43016,
		[
			16
		]
	],
	"./it/states.json5": [
		70042,
		[
			42
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 98115;
module.exports = webpackAsyncContext;